import { render, staticRenderFns } from "./LayoutFormCustomer.vue?vue&type=template&id=5aaec01a&"
import script from "./LayoutFormCustomer.vue?vue&type=script&lang=js&"
export * from "./LayoutFormCustomer.vue?vue&type=script&lang=js&"
import style0 from "./LayoutFormCustomer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports